import { render, staticRenderFns } from "./ClientVerticalHeader.vue?vue&type=template&id=71daf90c&scoped=true&"
import script from "./ClientVerticalHeader.vue?vue&type=script&lang=js&"
export * from "./ClientVerticalHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71daf90c",
  null
  
)

export default component.exports